import { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What tools do you use to source?',
      answer: 'We use proprietary technology to scan a wide range of signals including Twitter, GitHub, Product Hunt, Trends, and niche communities like Partiful and Luma. We track who follows who and map social graphs to find breakout founders faster than anyone else.'
    },
    {
      question: 'How does Cappuccino learn our thesis?',
      answer: 'We ingest your public investment history, thesis decks, and any anti-portfolio data you provide. Our models tune themselves to your specific definition of \'high signal\' over time.'
    },
    {
      question: 'What does pricing look like?',
      answer: 'We offer flexible plans for individual associates and firm-wide deployments. Book a demo to discuss your specific needs.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">FAQ.</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <span>{faq.question}</span>
              <span className="faq-icon">{openIndex === index ? '×' : '+'}</span>
            </button>
            {openIndex === index && (
              <div className="faq-answer">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
